export default {
  "name": "The present moment of a thousand small things",
  "slug": "the-present-moment-of-a-thousand-small-things",
  "path": "/the-present-moment-of-a-thousand-small-things",
  "componentName" : "ThePresentMomentOfAThousandSmallThings",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}